var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzurelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1204_8766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09799 0.512036H8.85668L4.95476 12.0798C4.93481 12.1389 4.90577 12.1945 4.86869 12.2447C4.8317 12.2948 4.78708 12.3388 4.73642 12.3752C4.68577 12.4115 4.62988 12.4398 4.57049 12.4589C4.5111 12.4779 4.44917 12.4878 4.38693 12.4878H1.46171C1.36676 12.4878 1.27307 12.4652 1.1886 12.4217C1.10403 12.3783 1.03103 12.3154 0.975661 12.2381C0.920252 12.1609 0.884004 12.0716 0.869907 11.9776C0.855775 11.8836 0.864349 11.7875 0.894678 11.6975L4.53 0.919648C4.54985 0.860579 4.5789 0.805002 4.61606 0.754825C4.65306 0.704648 4.69784 0.660663 4.74833 0.6243C4.79899 0.587938 4.85488 0.559673 4.91427 0.540618C4.97365 0.521564 5.03558 0.511719 5.09783 0.511719V0.511878L5.09799 0.512036Z",
    fill: "url(#paint0_linear_1204_8766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.028 12.4879H8.65297C8.61533 12.4879 8.5777 12.4844 8.54054 12.4772C8.50355 12.4703 8.46718 12.4598 8.43209 12.446C8.397 12.4322 8.36334 12.415 8.33142 12.395C8.29954 12.3749 8.26961 12.3518 8.24202 12.3261L4.41203 8.7492C4.37152 8.71137 4.3433 8.66224 4.33104 8.60819C4.31879 8.55413 4.3231 8.49764 4.34341 8.44607C4.36372 8.3945 4.39908 8.35023 4.44489 8.31904C4.49078 8.28791 4.54493 8.27124 4.60035 8.27124H10.5607L12.0277 12.488L12.028 12.4879Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86912 0.512214L6.23798 8.27208L10.537 8.27113L12.0117 12.4879H8.64935C8.61458 12.4876 8.57981 12.4844 8.54551 12.4783C8.51121 12.4721 8.47755 12.463 8.44483 12.4509C8.37924 12.427 8.31823 12.3921 8.26445 12.3476L5.67904 9.93461L4.95528 12.0691C4.93655 12.1224 4.91082 12.1731 4.87875 12.2196C4.81446 12.3132 4.72652 12.3881 4.62389 12.4366C4.57279 12.4608 4.5187 12.4781 4.46304 12.4879H1.4624C1.36649 12.4883 1.27185 12.4654 1.18658 12.4212C1.1013 12.3771 1.02789 12.3131 0.972556 12.2347C0.917224 12.1562 0.881596 12.0656 0.868685 11.9704C0.855821 11.8753 0.866004 11.7784 0.898379 11.688L4.52782 0.927925C4.54672 0.867743 4.57514 0.811056 4.61198 0.759926C4.64866 0.708796 4.69344 0.663699 4.74425 0.626543C4.79507 0.589386 4.85159 0.560486 4.91146 0.541114C4.97132 0.521742 5.03404 0.511897 5.09708 0.512214H8.86928H8.86912Z",
    fill: "url(#paint1_linear_1204_8766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5336 11.6976C13.564 11.7877 13.5725 11.8837 13.5586 11.9777C13.5445 12.0717 13.5083 12.161 13.453 12.2383C13.3976 12.3155 13.3246 12.3784 13.2401 12.4218C13.1556 12.4652 13.0619 12.4879 12.9669 12.4879H8.77774C8.87269 12.4879 8.96638 12.4652 9.05102 12.4219C9.13549 12.3785 9.20853 12.3155 9.26395 12.2383C9.31937 12.1611 9.35557 12.0717 9.36971 11.9777C9.38384 11.8837 9.37526 11.7877 9.34493 11.6976L5.70946 0.919501C5.66944 0.800772 5.59318 0.697586 5.49144 0.624471C5.44094 0.588108 5.38505 0.560003 5.32582 0.540948C5.26659 0.521893 5.20466 0.512207 5.14258 0.512207H9.3316C9.39384 0.512207 9.45561 0.521893 9.515 0.540948C9.57422 0.560003 9.63012 0.588267 9.68077 0.624471C9.73127 0.660834 9.77589 0.704818 9.81289 0.754837C9.84988 0.804855 9.87878 0.860432 9.89879 0.919501L13.5343 11.6976H13.5336Z",
    fill: "url(#paint2_linear_1204_8766)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1204_8766",
    x1: 6.46977,
    y1: 1.39967,
    x2: 2.56355,
    y2: 12.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1204_8766",
    x1: 7.68662,
    y1: 6.77645,
    x2: 6.78311,
    y2: 7.08291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1204_8766",
    x1: 7.18858,
    y1: 1.06321,
    x2: 11.4759,
    y2: 12.4849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1204_8766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7173,
    height: 12,
    fill: "white",
    transform: "translate(0.855469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurelogo);
export default __webpack_public_path__ + "static/media/azurelogo.1d62903f5e3105acba4d7b74f2020556.svg";
export { ForwardRef as ReactComponent };